









import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class Container extends Vue {
  get imageUrl() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.users.getCompanyCode}/CANDIDATEPORTAL/DownloadAppsBackground.png`;
  }
}
